import React from 'react';
import styles from './LightTableLineContainer.module.scss';

const LightTableLineContainer = ({ children }) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  );
};

export default LightTableLineContainer;
